<template>
    <nav aria-label="Page navigation example">
    <ul class="pagination">
        <li class="page-item" :class="{'disabled': isOnFirstPage}">
            <a href="" @click.prevent="loadPage('prev')" class="page-link">
                <span>&laquo;</span>
            </a>
        </li>

        <template v-if="notEnoughPages">
            <li class="page-item" v-for="n in totalPage" :class="{'active': isCurrentPage(n)}" v-bind:key="n">
                <a @click.prevent="loadPage(n)" v-html="n" class="page-link"></a>
            </li>
        </template>
        <template v-else>
            <li class="page-item" v-for="n in windowSize" :class="{'active': isCurrentPage(windowStart+n-1)}" v-bind:key="n">
                <a @click.prevent="loadPage(windowStart+n-1)" v-html="windowStart+n-1" class="page-link"></a>
            </li>
        </template>

        <li class="page-item" :class="{'disabled': isOnLastPage}">
            <a href="" @click.prevent="loadPage('next')" class="page-link">
                <span>&raquo;</span>
            </a>
        </li>
    </ul>
    </nav>
</template>

<script>
import VuetablePaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin'
export default {
  name: 'VuetablePaginationBootstrap',
  mixins: [VuetablePaginationMixin]
}
</script>



// WEBPACK FOOTER //
// src/components/core/VuetablePaginationBootstrap.vue